/**
 * Centralized Pricing & Sequential 3-Level Discount Service
 * Formula: MRP -> Product Discount % -> Category Discount % -> Site Discount %
 */

export function calculateFinalPrice(mrp, productDiscountPct = 0, categoryDiscountPct = 0, siteDiscountPct = 0) {
  const numericMrp = Math.max(0, Number(mrp) || 0);
  const pDiscount = Math.min(100, Math.max(0, Number(productDiscountPct) || 0));
  const cDiscount = Math.min(100, Math.max(0, Number(categoryDiscountPct) || 0));
  const sDiscount = Math.min(100, Math.max(0, Number(siteDiscountPct) || 0));

  const afterProduct = numericMrp * (1 - pDiscount / 100);
  const afterCategory = afterProduct * (1 - cDiscount / 100);
  const finalPrice = afterCategory * (1 - sDiscount / 100);

  // Round currency to 2 decimal places or nearest integer depending on currency
  return Math.round(finalPrice * 100) / 100;
}

export function calculateSavings(mrp, finalPrice) {
  const numericMrp = Math.max(0, Number(mrp) || 0);
  const numericFinal = Math.max(0, Number(finalPrice) || 0);
  return Math.max(0, Math.round((numericMrp - numericFinal) * 100) / 100);
}

export function calculateEffectiveDiscountPct(mrp, finalPrice) {
  const numericMrp = Math.max(0, Number(mrp) || 0);
  if (numericMrp === 0) return 0;
  const numericFinal = Math.max(0, Number(finalPrice) || 0);
  const savings = Math.max(0, numericMrp - numericFinal);
  return Math.round((savings / numericMrp) * 100);
}
